var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216.963,
    height: 216.974,
    viewBox: "0 0 216.963 216.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-person",
    "data-name": "Icon ionic-ios-person",
    d: "M221.356,215.993c-4.068-17.968-27.291-26.726-35.315-29.551-8.815-3.108-21.358-3.842-29.438-5.65-4.633-1.017-11.357-3.56-13.617-6.272s-.9-27.856-.9-27.856a83.809,83.809,0,0,0,6.441-12.261c2.26-5.707,4.746-21.415,4.746-21.415s4.633,0,6.272-8.137c1.752-8.871,4.52-12.318,4.181-18.929-.339-6.5-3.9-6.328-3.9-6.328s3.447-9.436,3.842-28.986C164.174,27.384,145.98,4.5,113.039,4.5c-33.394,0-51.192,22.884-50.684,46.107.452,19.55,3.786,28.986,3.786,28.986s-3.56-.17-3.9,6.328c-.339,6.611,2.43,10.058,4.181,18.929,1.582,8.137,6.272,8.137,6.272,8.137s2.486,15.708,4.746,21.415a83.809,83.809,0,0,0,6.441,12.261s1.356,25.144-.9,27.856-8.984,5.255-13.617,6.272c-8.08,1.808-20.624,2.543-29.438,5.65C31.9,189.267,8.677,198.025,4.608,215.993a4.517,4.517,0,0,0,4.464,5.481H216.949A4.507,4.507,0,0,0,221.356,215.993Z",
    transform: "translate(-4.501 -4.5)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePreview);
export default __webpack_public_path__ + "static/media/profile-preview.add24978267de5071c75a025a414a4a5.svg";
export { ForwardRef as ReactComponent };